import { useEffect } from "react";

interface ConfirmDialogProps {
  open: boolean;
  title?: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  icon?: string;
  onCancel: () => void;
  onConfirm: () => void;
}

export default function ConfirmDialog({
  open,
  title = "Confirmar",
  message,
  confirmLabel = "Eliminar",
  cancelLabel = "Cancelar",
  icon = "ri-delete-bin-line",
  onCancel,
  onConfirm,
}: ConfirmDialogProps) {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center px-8">
      <button
        type="button"
        aria-label="Cerrar"
        onClick={onCancel}
        className="absolute inset-0 bg-black/40 backdrop-blur-[2px]"
      />
      <div className="fr-sheet relative w-full max-w-[320px] rounded-4xl bg-background-50 p-5 text-center shadow-float">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-red-100 text-red-600">
          <i className={`${icon} text-2xl`} />
        </div>
        <h2 className="mt-3 text-[16px] font-bold text-foreground-950">{title}</h2>
        <p className="mt-1.5 text-[13px] leading-relaxed text-foreground-600">{message}</p>
        <div className="mt-5 grid grid-cols-2 gap-3">
          <button
            type="button"
            onClick={onCancel}
            className="rounded-2xl border border-background-300 bg-background-100 py-3 text-[14px] font-semibold text-foreground-700 active:scale-[0.99]"
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="rounded-2xl bg-red-600 py-3 text-[14px] font-semibold text-white active:scale-[0.99]"
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}